import { useWizard } from '../../context/WizardContext';

export function ProgressBar() {
  const { progress } = useWizard();

  return (
    <div className="fixed top-0 left-0 right-0 h-1 bg-gray-200 z-50">
      <div
        className="h-full bg-primary-500 transition-all duration-500 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
